import { useEffect, useState } from 'react'
import '@common/reset.css'
import './style.scss'

export default function App({}) {
	const [projectes, setProjectes] = useState(null)
	const [url, setUrl] = useState(null)

	useEffect(() => {
		fetch(`${process.env.API_CLIENT}/projectes`)
			.then((res) => res.json())
			.then((json) => setProjectes(json))
			.catch((error) => console.log(error))
		setUrl(window.location.href)
	}, [])

	if (!projectes || !url) return <>Carregant...</>

	return (
		<>
			<h1>Widgets Diari ARA</h1>
			{!url.includes('https://widgets.ara.cat') && (
				<ul>
					{projectes.map((projecte) => (
						<li key={projecte}>
							<a href={`${url}${projecte}?preview=1`}>{projecte.split('-').join(' ').toUpperCase()}</a>
						</li>
					))}
				</ul>
			)}
		</>
	)
}
